<template>

  <div :class="sidebarClasses"
       :data-background-color="partnerStyles.name"
       :data-active-color="activeColor">
    <div class="logo">
      <router-link  to="/">
      <a class="simple-text logo-mini"
         href="javascript:void(0)">
       
          <div class="logo-img">
            <img :src="logo" alt="">
           
          </div>
      </a>
      </router-link>
     
    </div> 
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul :class="navClasses">
 
 <slot name="links" v-if="user.name=='tefl'">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
       
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
   
    props: {
      title: {
        type: String,
        default: 'Admin System'
      },
     
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
       
      partnerStyles:{},

      activeColor: {
        type: String,
        default: 'primary',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: 'static/img/TEFL-Logo-White.svg'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    computed: {

     
        user(){
             const profile = this.$store.getters.getProfile;
     
          return profile
        },
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
     
      getpartnerStyles(){
        return this.partnerStyles.name
      },
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
.logo{padding:10px !important;margin:0 auto !important;}
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue